import twitter_icon from './images/social/twitter_icon.svg'
import tiktok_icon from './images/social/tiktok_icon.svg'
import medium_icon from './images/social/medium_icon.svg'
import telegram_icon from './images/social/telegram_icon.svg'
import discord_icon from './images/social/discord_icon.svg'
import email_icon from './images/social/email_icon.svg'
import yolorekt_logo_stacked_SOLID_FFFFFF from './images/yolorekt_logo-stacked-SOLID-FFFFFF.svg'
import yolobot_logo_2 from './images/yolobot_logo_2.svg'
import yolobot_bg_4 from './images/yolobot_bg_4.jpg'
import telegram_logo from './images/icons/telegram_logo.svg'

export const resources = {
  twitter_icon,
  tiktok_icon,
  medium_icon,
  telegram_icon,
  telegram_logo,
  discord_icon,
  email_icon,
  yolorekt_logo_stacked_SOLID_FFFFFF,
  yolobot_logo_2,
  yolobot_bg_4,
}
